<template>
  <svg
    fill="none"
    viewBox="0 0 50 50"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M13.9167 38.25H34.3333C35.1069 38.25 35.8487 37.9427 36.3957 37.3957C36.9427 36.8487 37.25 36.1069 37.25 35.3333V14.9167C37.25 14.1431 36.9427 13.4013 36.3957 12.8543C35.8487 12.3073 35.1069 12 34.3333 12H13.9167C13.1431 12 12.4013 12.3073 11.8543 12.8543C11.3073 13.4013 11 14.1431 11 14.9167V35.3333C11 36.1069 11.3073 36.8487 11.8543 37.3957C12.4013 37.9427 13.1431 38.25 13.9167 38.25ZM18.2917 28.0417L21.7377 31.4877L27.0417 23.6667L34.3333 33.875H13.9167L18.2917 28.0417Z"
    />
  </svg>
</template>
